import { ShortCode } from '@highereducation/wordpress';
import { ImageGridProps, ImageGrid } from '@highereducation/hen-ui';

interface ImageGridShortcodeProps extends ImageGridProps {
  [key: string]: any;
}

export const ImageGridShortcode: ShortCode<ImageGridShortcodeProps> = {
  component: ({ children, ...args }) => {
    return <ImageGrid {...args}>{children}</ImageGrid>;
  },
};
